<template>
  <w-flex justify-center align-center v-if="($zutil.role('1') || $zutil.role('2') || $zutil.role('5'))&& $page.props.auth.user.id == data.user_id">
   <!--  <div class="w-card__content content-hardcode"> -->
     <!--  <w-flex class="mt3">
        <div class="xs11 text-right" >
          <inertia-link :href="$route('art.form',0)+'?premis_id='+data.id" class="w-button green--bg  w-button--dark size--md  ml1"> 
             <w-icon class="mr1">fal fa-plus</w-icon> Tambah
          </inertia-link>
        </div>
      </w-flex> -->
    <!-- </div> -->
  </w-flex>
  <div class="w-table-wrap" >
    <table class="w-table" color="light" >
      <thead>
        <tr>
          <th class="w-table__header  text-left" width="1%">No</th>
          <th class="w-table__header  text-left" width="140px">No Permohonan</th>
          <th class="w-table__header  text-left" width="120px">Tarikh Mohon / Masa </th>
          <th class="w-table__header  text-left">Jenis Perkhidmatan</th>
          <!-- <th class="w-table__header  text-left">ID Premis/ Nama Premis</th> -->
          <th class="w-table__header  text-left">Nama Juruteknik/ Jurusuntik</th>
          <th class="w-table__header  text-left">Tarikh Check In</th>
          <th class="w-table__header  text-left">Status</th>
          <th class="w-table__header  text-left"  width="1%">Tindakan</th>
        </tr>
      </thead>

      <tbody>
        <template v-if="datas.length == 0">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
          </tr>
        </template>
        <template v-for="(dt, ind) in datas">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" style="padding-top:10px">{{ind+1}}</td>
            <td class="w-table__cell text-left" style="padding-top:10px">{{dt.no_permohonan}}</td>
            <td class="w-table__cell text-left" style="padding-top:10px">{{dt.tarikh}}{{dt.masa}}</td>
            <td class="w-table__cell text-left" style="padding-top:10px">{{dt.lkp_art}}</td>
            <!-- <td class="w-table__cell text-left" >{{dt.premis}}</td> -->
            <td class="w-table__cell text-left" style="padding-top:10px">{{dt.juruteknik}}</td>
            <td class="w-table__cell text-left" style="padding-top:10px">{{dt.tarikh}}</td>
            <td class="w-table__cell text-left" style="padding-top:10px">{{dt.status}}</td>
            <td class="w-table__cell text-left" >
               <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                       <inertia-link :href="$route('art.permohonan.show',dt.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div>
                        <w-icon md class="mr2">fal fa-eye</w-icon>
                     </inertia-link>
                </template>
               PAPAR
            </w-tooltip>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>


</template>

<script>
export default {
  name: "Pemilik",
  props:{
    data: [Array, Object],
  },
  data() {
    return {
      form : {},
      datas : [],
      
    }
  },
  methods:{
    getData(){
      this.$zcomm.get(this.api_service + 'premis/art/'+this.data.id, {}).then(res => {
        this.datas = res
      })
    },
    
  },
      
  mounted() {
    this.getData()
    
  }
}
      

</script>  
